import { NAVIGATION_URLS } from '@libs/core';

export const ADOPTION_COUNT = {
    LINK: NAVIGATION_URLS.legacy.petAdoption,
    TEXT: 'Adoptions',
};
